export default function(string) {
    return new Handlebars.SafeString((string || '').toLowerCase());
}